module.exports = "<div class=\"\">\n    <!-- header component -->\n    <appc-header></appc-header>\n\n    <!-- component routing placeholder -->\n    <router-outlet></router-outlet>\n\n    <!-- footer component -->\n    <appc-footer></appc-footer>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main